<!-- AASA Universal Link 경로: /coupon/* (apple-app-site-association에 등록됨) -->
<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import OnBoardingPage from '@/components/common/OnBoardingPage.vue';

definePage({ meta: { layout: 'empty', public: true } });

const route = useRoute();
const router = useRouter();
const showOnboarding = ref(false);

const redirectUrl = computed(() => {
  const serial = route.query.serial;
  return serial
    ? `/purchase/gift-box?tab=coupon&serial=${serial}`
    : '/purchase/gift-box?tab=coupon';
});

const STORE_URL = {
  google: 'https://play.google.com/store/apps/details?id=com.twofivedosajuapp&hl=ko',
  apple:
    'https://apps.apple.com/kr/app/%EB%82%AD%EB%A7%8C-%EB%A7%8C%EC%84%B8%EB%A0%A5/id6462405118',
};

onMounted(() => {
  const serial = route.query.serial;
  const userAgent = navigator.userAgent;

  const isIOS = /iPhone|iPad|iPod/.test(userAgent);
  const isAndroid = /Android/.test(userAgent);

  if (isIOS) {
    window.location.href = STORE_URL.apple;
    setTimeout(() => { showOnboarding.value = true; }, 2000);
  } else if (isAndroid) {
    window.location.href = STORE_URL.google;
    setTimeout(() => { showOnboarding.value = true; }, 2000);
  } else {
    // 웹 브라우저: 선물함 쿠폰 탭으로 이동
    router.replace({ path: '/purchase/gift-box', query: { tab: 'coupon', ...(serial ? { serial } : {}) } });
  }
});
</script>

<template>
  <OnBoardingPage v-if="showOnboarding" :redirect-url="redirectUrl" />
  <div v-else class="app-redirect">
    <div class="loading">
      <div class="spinner"></div>
      <p>이동 중...</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.app-redirect {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-family: Pretendard, sans-serif;
  background-color: #f5f5f5;
}

.loading {
  text-align: center;
  color: #333;

  .spinner {
    width: 40px;
    height: 40px;
    margin: 0 auto 16px;
    border: 3px solid #e5e5e5;
    border-top-color: #eb4c10;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  p {
    font-size: 16px;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
